define(function(require) {
    // RESEAU_COLLEGIAL themeset definition config
    return  {
        ID : "FREQUENTATION_ALL",
        TYPE : "ThemeSetGroup",
        TITLE : "Par lieux de fréquentation de l'élève",
        THEMESETS_ELEMENTS : [
            {
                ID : "FREQUENTATION_FRA_STA",
                TYPE : "ThemeSetGroup",
                TITLE : "Centre de services scolaire et commission scolaire francophone et à statut particulier",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Freq_GEO09E01_CS_FRA_STA_GEN_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 5 ans",
                        SELECTED_DATAVIEW_LAYER : "GEO09E01_CS_FRA_STA_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E01_CS_FRA_STA_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E01_CS_FRA_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_5_M_{{VALUE}}", "TX_5_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 5 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "FRA_TX_5_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E01_CS_FRA_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_5_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 5 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "FRA_TX_5_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 60,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 60%"
                                      }, {
                                          MIN_VALUE : 60,
                                          MAX_VALUE : 63,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "60% à 63%"
                                      }, {
                                          MIN_VALUE : 63,
                                          MAX_VALUE : 66,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "63% à 66%"
                                      }, {
                                          MIN_VALUE : 66,
                                          MAX_VALUE : 69,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "66% à 69%"
                                      }, {
                                          MIN_VALUE : 69,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "69% et plus"
                                      }]
                                },
                            },
                        ]
                    }, {
                        ID : "Freq_GEO09E01_CS_FRA_STA_GEN_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 7 ans",
                        SELECTED_DATAVIEW_LAYER : "GEO09E01_CS_FRA_STA_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E01_CS_FRA_STA_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E01_CS_FRA_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_7_M_{{VALUE}}", "TX_7_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 7 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "FRA_TX_7_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E01_CS_FRA_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_7_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 7 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "FRA_TX_7_T",
                                    SCHEME_ELEMENTS : [
                                      {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 73,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 73%"
                                      }, {
                                          MIN_VALUE : 73,
                                          MAX_VALUE : 76,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "73% à 76%"
                                      }, {
                                          MIN_VALUE : 76,
                                          MAX_VALUE : 79,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "76% à 79%"
                                      }, {
                                          MIN_VALUE : 79,
                                          MAX_VALUE : 82,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "79% à 82%"
                                      }, {
                                          MIN_VALUE : 82,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "82% et plus"
                                      }]
                                },
                            },
                        ]
                    }
                ]
            }, {
                ID : "FREQUENTATION_ANG_STA",
                TYPE : "ThemeSetGroup",
                TITLE : "Centre de services scolaire et commission scolaire anglophone et à statut particulier",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Freq_GEO09E02_CS_ANG_STA_GEN_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 5 ans",
                        SELECTED_DATAVIEW_LAYER : "GEO09E02_CS_ANG_STA_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E02_CS_ANG_STA_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E02_CS_ANG_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_5_M_{{VALUE}}", "TX_5_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 5 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "ANG_TX_5_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E02_CS_ANG_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_5_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 5 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "ANG_TX_5_T",
                                    SCHEME_ELEMENTS : [
                                    {
                                        MIN_VALUE : 0,
                                        MAX_VALUE : 60,
                                        REPRESENTATION : "rgba(251,242,196,1)",
                                        LEGEND_TEXT : "Moins de 60%"
                                    }, {
                                        MIN_VALUE : 60,
                                        MAX_VALUE : 63,
                                        REPRESENTATION : "rgba(229,193,133,1)",
                                        LEGEND_TEXT : "60% à 63%"
                                    }, {
                                        MIN_VALUE : 63,
                                        MAX_VALUE : 66,
                                        REPRESENTATION : "rgba(224,162,120,1)",
                                        LEGEND_TEXT : "63% à 66%"
                                    }, {
                                        MIN_VALUE : 66,
                                        MAX_VALUE : 69,
                                        REPRESENTATION : "rgba(219,131,107,1)",
                                        LEGEND_TEXT : "66% à 69%"
                                    }, {
                                        MIN_VALUE : 69,
                                        MAX_VALUE : 100,
                                        REPRESENTATION : "rgba(199,82,42,1)",
                                        LEGEND_TEXT : "69% et plus"
                                    }]
                                },
                            },
                        ]
                    }, {
                        ID : "Freq_GEO09E02_CS_ANG_STA_GEN_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 7 ans",
                        SELECTED_DATAVIEW_LAYER : "GEO09E02_CS_ANG_STA_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E02_CS_ANG_STA_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E02_CS_ANG_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_7_M_{{VALUE}}", "TX_7_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 7 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "ANG_TX_7_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E02_CS_ANG_STA_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_7_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 7 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "ANG_TX_7_T",
                                    SCHEME_ELEMENTS : [
                                      {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 73,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 73%"
                                      }, {
                                          MIN_VALUE : 73,
                                          MAX_VALUE : 76,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "73% à 76%"
                                      }, {
                                          MIN_VALUE : 76,
                                          MAX_VALUE : 79,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "76% à 79%"
                                      }, {
                                          MIN_VALUE : 79,
                                          MAX_VALUE : 82,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "79% à 82%"
                                      }, {
                                          MIN_VALUE : 82,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "82% et plus"
                                      }]
                                },
                            },
                        ]
                    }
                ]
            }, {
                ID : "FREQUENTATION_RA",
                TYPE : "ThemeSetGroup",
                TITLE : "Régions administratives",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Freq_REG_ADM_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 5 ans",
                        MASTER_THEMESETS_REMOVE: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017"],
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_5_M_{{VALUE}}", "TX_5_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 5 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "RA_TX_5_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_5_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 5 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_5_T",
                                    SCHEME_ELEMENTS : [
                                      {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 60,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 60%"
                                      }, {
                                          MIN_VALUE : 60,
                                          MAX_VALUE : 63,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "60% à 63%"
                                      }, {
                                          MIN_VALUE : 63,
                                          MAX_VALUE : 66,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "63% à 66%"
                                      }, {
                                          MIN_VALUE : 66,
                                          MAX_VALUE : 69,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "66% à 69%"
                                      }, {
                                          MIN_VALUE : 69,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "69% et plus"
                                      }]
                                },
                            },
                        ]
                    }, {
                        ID : "Freq_REG_ADM_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 5 ans",
                        MASTER_THEMESETS_REMOVE: ["2018"],
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : true},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_5_M_{{VALUE}}", "TX_5_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 5 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "RA_TX_5_FM_HACHURE",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 5 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_5_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 5 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_5_T_HACHURE",
                                    SCHEME_ELEMENTS : [
                                      {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 60,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 60%"
                                      }, {
                                          MIN_VALUE : 60,
                                          MAX_VALUE : 63,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "60% à 63%"
                                      }, {
                                          MIN_VALUE : 63,
                                          MAX_VALUE : 66,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "63% à 66%"
                                      }, {
                                          MIN_VALUE : 66,
                                          MAX_VALUE : 69,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "66% à 69%"
                                      }, {
                                          MIN_VALUE : 69,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "69% et plus"
                                      }]
                                },
                            },
                        ]
                    }, {
                        ID : "Freq_REG_ADM_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 7 ans",
                        MASTER_THEMESETS_REMOVE: ["1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"],
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_7_M_{{VALUE}}", "TX_7_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 7 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "RA_TX_7_FM",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_7_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 7 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_7_T",
                                    SCHEME_ELEMENTS : [
                                      {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 73,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 73%"
                                      }, {
                                          MIN_VALUE : 73,
                                          MAX_VALUE : 76,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "73% à 76%"
                                      }, {
                                          MIN_VALUE : 76,
                                          MAX_VALUE : 79,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "76% à 79%"
                                      }, {
                                          MIN_VALUE : 79,
                                          MAX_VALUE : 82,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "79% à 82%"
                                      }, {
                                          MIN_VALUE : 82,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "82% et plus"
                                      }]
                                },
                            },
                        ]
                    }, {
                        ID : "Freq_REG_ADM_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux de diplomation et qualification par cohorte au secondaire après 7 ans",
                        MASTER_THEMESETS_REMOVE: ["2016", "2017", "2018"],
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09_WEB_MERCATOR_GEO09E01_CS_FRA", VISIBLE : true},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE: "BarChartOverlayTheme",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMNS_IDS: ["TX_7_M_{{VALUE}}", "TX_7_F_{{VALUE}}"],
                                AS_OVERLAY : true,
                                ENABLED : true,
                                DEFAULT_SIZE: 24,
                                IS_GRADUATED: false,
                                LEGEND_TEXT: "Taux après 7 ans, par sexe, cohorte de {{TEXT}}",
                                REPRESENTATION_ENUM: "color",
                                SCHEME: {
                                    ID : "RA_TX_7_FM_HACHURE",
                                    SCHEME_ELEMENTS : [
                                        {
                                            REPRESENTATION: "rgba(9,87,151,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe masculin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe masculin"
                                        }, {
                                            REPRESENTATION: "rgba(104,206,186,1)",
                                            VALUE: "Taux de diplomation et qualification par cohorte au secondaire après 7 ans, sexe féminin, cohorte de {{TEXT}}",
                                            LEGEND_TEXT: "Sexe féminin"
                                        }
                                    ]
                                },
                            }, {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_frequentation",
                                DATACOLUMN_ID : "TX_7_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Intervalle des classes du taux de la cohorte de {{TEXT}} après 7 ans, sexes réunis",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_7_T_HACHURE",
                                    SCHEME_ELEMENTS : [
                                      {
                                          MIN_VALUE : 0,
                                          MAX_VALUE : 73,
                                          REPRESENTATION : "rgba(251,242,196,1)",
                                          LEGEND_TEXT : "Moins de 73%"
                                      }, {
                                          MIN_VALUE : 73,
                                          MAX_VALUE : 76,
                                          REPRESENTATION : "rgba(229,193,133,1)",
                                          LEGEND_TEXT : "73% à 76%"
                                      }, {
                                          MIN_VALUE : 76,
                                          MAX_VALUE : 79,
                                          REPRESENTATION : "rgba(224,162,120,1)",
                                          LEGEND_TEXT : "76% à 79%"
                                      }, {
                                          MIN_VALUE : 79,
                                          MAX_VALUE : 82,
                                          REPRESENTATION : "rgba(219,131,107,1)",
                                          LEGEND_TEXT : "79% à 82%"
                                      }, {
                                          MIN_VALUE : 82,
                                          MAX_VALUE : 100,
                                          REPRESENTATION : "rgba(199,82,42,1)",
                                          LEGEND_TEXT : "82% et plus"
                                      }]
                                },
                            },
                        ]
                    }
                ]
            }
        ]
    };
});
